var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3641 4.23431C13.6765 4.54673 13.6765 5.05327 13.3641 5.36569L6.96412 11.7657C6.6517 12.0781 6.14517 12.0781 5.83275 11.7657L2.63275 8.56569C2.32033 8.25327 2.32033 7.74673 2.63275 7.43431C2.94517 7.1219 3.4517 7.1219 3.76412 7.43431L6.39844 10.0686L12.2328 4.23431C12.5452 3.9219 13.0517 3.9219 13.3641 4.23431Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.9e8197bab157ffb300bf264c59f1d750.svg";
export { ForwardRef as ReactComponent };